import { default as Form } from 'antd/es/form';
import { default as Input } from 'antd/es/input';
import Select from 'antd/es/select';

import type { PostCustomerUsersBodyData } from 'api';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import { userManagementNewUserT as translations } from './translations';

import {
  NEW_USER_CANCEL_TEST_ID,
  NEW_USER_EMAIL_TEST_ID,
  NEW_USER_FIRST_NAME_TEST_ID,
  NEW_USER_LAST_NAME_TEST_ID,
  NEW_USER_ROLE_INFO_TEST_ID,
  NEW_USER_ROLE_TEST_ID,
  NEW_USER_SUBMIT_TEST_ID,
  USER_ROLES_INFO
} from '../constants';

type Props = {
  form: any;
  onFinish: (values: PostCustomerUsersBodyData) => void | Promise<void>;
  onCancel: () => void;
  roleOptions: { label: string; value: string; disabled?: boolean }[];
  selectedRole?: string;
  isSubmitting?: boolean;
};

export const NewUserDialogForm = ({
  form,
  onFinish,
  onCancel,
  roleOptions,
  selectedRole,
  isSubmitting
}: Props) => {
  const t = translations.createUserDialog;

  return (
    <Form form={form} onFinish={onFinish} layout="vertical" autoComplete="off">
      <div className="flex flex-col">
        <Form.Item
          label={t.fields.firstName}
          name="first_name"
          rules={[{ required: true, message: t.messages.firstNameRequired }]}
        >
          <Input
            data-testid={NEW_USER_FIRST_NAME_TEST_ID}
            className="h-[47px]"
            placeholder={t.placeholders.firstName}
          />
        </Form.Item>

        <Form.Item
          label={t.fields.lastName}
          name="last_name"
          rules={[{ required: true, message: t.messages.lastNameRequired }]}
        >
          <Input
            data-testid={NEW_USER_LAST_NAME_TEST_ID}
            className="h-[47px]"
            placeholder={t.placeholders.lastName}
          />
        </Form.Item>

        <Form.Item
          label={t.fields.email}
          name="email"
          rules={[
            { required: true, message: t.messages.emailRequired },
            { type: 'email', message: t.messages.emailInvalid }
          ]}
        >
          <Input
            data-testid={NEW_USER_EMAIL_TEST_ID}
            className="h-[47px]"
            placeholder={t.placeholders.email}
            type="email"
          />
        </Form.Item>

        <Form.Item
          label={t.fields.role}
          name="role"
          rules={[{ required: true, message: t.messages.roleRequired }]}
        >
          <Select
            data-testid={NEW_USER_ROLE_TEST_ID}
            className="h-[47px]"
            options={roleOptions}
            placeholder={t.placeholders.role}
          />
        </Form.Item>

        {selectedRole && (
          <div
            data-testid={NEW_USER_ROLE_INFO_TEST_ID}
            className="mb-4 rounded-md bg-surface-neutral px-4 py-2"
          >
            {USER_ROLES_INFO[selectedRole.replace(' ', '_')]}
          </div>
        )}

        <div className="flex justify-center gap-3">
          <SecondaryButton
            data-testid={NEW_USER_CANCEL_TEST_ID}
            className="flex-1"
            size="large"
            onClick={onCancel}
          >
            {t.actions.cancel}
          </SecondaryButton>

          <PrimaryButton
            data-testid={NEW_USER_SUBMIT_TEST_ID}
            className="flex-1"
            size="large"
            htmlType="submit"
            loading={isSubmitting}
          >
            {t.actions.submit}
          </PrimaryButton>
        </div>
      </div>
    </Form>
  );
};
